import React, { useState } from 'react';
import { Box, Button, Tooltip, CircularProgress } from '@material-ui/core';

import useAuth from './useAuth.js';
import MicrosoftLogo from '../support/MicrosoftLogo.js';

const SSOButton = ({ onAttempt, onSuccess, onError, text }) => {
    let auth = useAuth();
    const [loadingSSO, setLoadingSSO] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showError, setShowError] = useState(false);

    const sso = () => {
        setLoadingSSO(true);
        onAttempt?.();
        setTimeout(function () {
            auth.initSSO(window.location.href)
                .then((response) => {
                    setLoadingSSO(false);
                    setShowError(false);
                    onSuccess?.();
                })
                .catch((error) => {
                    console.log(error);
                    setShowError(true);
                    if (error.response) {
                        setErrorMessage(error.response.data.message);
                        onError?.(error.response.data.message);
                    }
                    else onError?.("Error");
                    setLoadingSSO(false);
                });
        }, 500);

    };
    return <Box style={{ position: 'relative', display: "inline-block", zIndex: 0, right:0, bottom:0 }}>
        <Tooltip title={errorMessage || "Error"} arrow open={showError}><><Button variant='contained' fullWidth startIcon={<MicrosoftLogo />}
            value={'SSO'} disabled={loadingSSO} onClick={sso} style={{ backgroundColor: loadingSSO ? '#999' : (showError ? 'maroon' : null) }}>{text ? text : "Microsoft Sign-on"}</Button>
            {loadingSSO ? <CircularProgress size={24} style={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-12px', marginLeft: '-12px', }} /> : null}
        </></Tooltip>
    </Box>;
};

export default SSOButton;